import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
  // A file whose every row is invalid produces one <li> per row, which would
  // otherwise grow the modal body without bound and push the Apply/close
  // controls off-screen. Same cap as the optimization-process modal uses.
  scrollableContent: {
    maxHeight: '500px',
    overflowY: 'auto',
    paddingRight: '0.5rem',
  },
})
